import { render, staticRenderFns } from "./ClaimsSectionContainer.vue?vue&type=template&id=49066592&scoped=true&"
import script from "./ClaimsSectionContainer.vue?vue&type=script&lang=js&"
export * from "./ClaimsSectionContainer.vue?vue&type=script&lang=js&"
import style0 from "./ClaimsSectionContainer.vue?vue&type=style&index=0&id=49066592&lang=styl&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49066592",
  null
  
)

export default component.exports